<template>
    <div>
        <div class="flex mt-10  justify-between md:flex-col">
            <div class="flex md:flex-col md:text-sm">
                <div>
                    <button class="cursor-pointer rounded-2xl p-3 border-blue-400 text-center bg-green-100 text-green-300 font-semibold" >
                        <span v-if="user.status === 'active' || user.status === 'pending' " class="pl-4 pr-4 text-red-500" @click="blockUser(user)">Block</span>
                        <span v-if="user.status === 'blocked' " class="pl-4 pr-4 text-red-500" @click="unblockUser(user)">Unblock</span>
                        <!-- <span v-if="user.status === 'pending' " class="pl-4 pr-4" style=" color: rgb(243, 243, 9);">Pending</span> -->

                    </button>
                </div>
                
                <div class="md:mt-2">
                    <button class="bg-green-100 p-3 rounded-xl ml-3 md:ml-0" @click="showModal">{{cashPaymentDisplay}}</button>
                    <!-- <button class="bg-green-100 p-3 rounded-xl ml-3 md:ml-0 md:mt-1 " @click="walletModal">{{walletPaymentDisplay}}</button> -->
                </div>   
            </div>
            <div class="md:mt-4 md:text-right mr-10 md:mr-0">
                <button @click="deleteUserModal(user)" class="bg-red-100 text-red-600 rounded-xl p-2"><i class="fa fa-trash mr-2"></i>Delete</button>
            </div>

        </div>
        <div class="flex justify-between mt-4"> 
            <div class="flex mt-4">
                <i class="fa fa-user text-blue-700"></i>
                <p class="ml-3">Profile Details</p>
            </div>
            <div class="flex">
                <p @click="setSelectedTab('user-analytics')" :class="{active: selectedTab === 'user-analytics'}"  class=" cursor-pointer mt-6 border-b border-gray-200">Analytics</p>
                <p @click="setSelectedTab('user-activity')" :class="{active: selectedTab === 'user-activity'}"  class="cursor-pointer mt-6 border-b border-gray-200 ml-20">Activity</p>
            </div>
        </div>
        <hr>
        <div class="mt-10 flex justify-between md:flex-col">
            <div>
                <div class="flex mt-2">
                    <p class="mr-8">Status</p>
                    <p class="mr-8 text-blue-700">{{user.status}}</p>
                </div>
                <div class="flex mt-2">
                    <p class="mr-8">Name:</p>
                    <p class="mr-8 text-blue-700">{{user.firstName}} {{user.lastName}}</p>
                </div>
                <div class="flex mt-2">
                    <p class="mr-8">Email:</p>
                    <p class="mr-8 text-blue-700">{{user.email}}</p>
                </div>
                <div class="flex mt-2">
                    <p class="mr-8">Phone Number:</p>
                    <p class="mr-8 text-blue-700">{{user.phone}}</p>
                </div>
                <div class="flex mt-2">
                    <p class="mr-8">Date Joined:</p>
                    <p class="mr-8 text-blue-700">{{moment(user.updated_at).format('DD/MM/YYYY')}}</p>
                </div>
                <div class="flex mt-2">
                    <p class="mr-8">User Type:</p>
                    <p class="mr-8 text-blue-700">{{user.userType}}</p>
                </div>
                <div class="flex mt-2">
                    <p class="mr-8">Account Number:</p>
                    <p class="mr-8 text-blue-700">{{userWallet.accountNumber}}</p>
                </div>
                <div class="flex mt-2">
                    <p class="mr-8">Account Name:</p>
                    <p class="mr-8 text-blue-700">{{userWallet.bankName}}</p>
                </div>
            </div>
           
                
           

            <component class="md:mt-8 mr-10 md:mr-0" :is="selectedTab"></component>

        </div>
        
        <div>
            <Modal
            v-show="isModalVisible"
            @close="closeModal"
            :firstName="user.firstName"
            :lastName="user.lastName"
            :cashPaymentStatus="cashPaymentStatus"
            :id="id"
            :message="message"
            :walletMessage="walletMessage"
            />

            <WalletModal
            v-show="isWalletVisible"
            @close="closeWalletModal"
            :firstName="user.firstName"
            :lastName="user.lastName"
            :walletPaymentStatus="walletPaymentStatus"
            :id="id"
            :message="message"
            />

        </div>

        <div>
            <DeleteModal
            v-show="deleteModal"
            @close="closeDeleteModal"
            :message="messaged"
            :userId="userId"
            />
        </div>
    </div>
</template>

<script>
import UserAnalytics from './UserAnalytics.vue';
import UserActivity from './UserActivity.vue';
import axios from 'axios';
import moment from 'moment';
import Modal from './Modal.vue';
import WalletModal from './WalletModal.vue';
import DeleteModal from '../DeleteModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    props: ['id'],
    components: {
        UserAnalytics,
        UserActivity,
        Modal,
        WalletModal,
        DeleteModal
    },

    data() {
        return {
            selectedTab: 'user-analytics',
            user: [],
            isModalVisible: false,
            cashPaymentStatus: Boolean,
            cashPaymentDisplay: "",
            walletPaymentStatus: Boolean,
            walletPaymentDisplay: "",
            message: "",
            walletMessage: "",
            isWalletVisible: false,
            isSuspendModal: false,
            suspendStatus: "",
            status: "",
            userStatus: "suspended",
            suspendUser: true,
            unSuspendUser: false,
            userWallet: [],
            blockStatus: "blocked",
            unblockStatus: "active",
            deleteModal: false,
            messaged: "",
            userId: ""
        };
    },

    mounted() {
        this.networkError();
        this.userInfo();
        this.paymentStatus();
        // this._suspendUser();
        this.getWalletAccountName();
    },

    methods: {
        moment(date) {
            return moment(date);
        },
        setSelectedTab(tab) {
            this.selectedTab = tab
        },

        closeDeleteModal() {
            this.deleteModal = false;
        },
        deleteUserModal(user) {
            this.userId = user.id;
            this.deleteModal = true;
            this.messaged =  "Are you sure you want to perform this action?"
        },

        showModal() {
            this.isModalVisible = true;
            if(this.cashPaymentStatus === true) {
                this.message = "Are you sure you want to Disable Cash Payment for";
            } else {
                this.message = "Are you sure you want to Enable Cash Payment for";
            }
        },

        walletModal() {
            this.isWalletVisible = true;
            if(this.walletPaymentStatus === true) {
                this.message = "Are you sure you want to Disable Wallet Payment for";
            } else {
                this.message = "Are you sure you want to Enable Wallet Payment for";
            }
        },

        _suspendUser() {  
          axios({
            method: 'GET',
            url: `${url}/v1/web/users/status/${this.id}/suspended`,
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer' + localStorage.getItem("token"),
                'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
            },
        })
        .then((response) => {
            let status = response.data.data.status;
            this.theStatus = response.data.data.status;
            if(status === "suspended") {
                this.status = "Unsuspend";
                this.unSuspendUser = true;
                this.suspendUser = false;
            }
            this.userInfo();
        }) 
        .catch((error) => {
            error.json
        })
      },
      _unSuspendUser() {  
          axios({
            method: 'GET',
            url: `${url}/v1/web/users/status/${this.id}/active`,
            headers: {
                'Content-type': 'application/json',
                Authorization: 'Bearer' + localStorage.getItem("token"),
                'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
            },
        })
        .then((response) => {
            let status = response.data.data.status;
            this.theStatus = response.data.data.status;
            if(status === "active") {
                this.suspendUser = true;
                this.unSuspendUser = false;
            }
            this.userInfo();
        }) 
        .catch((error) => {
            error.json
        })
      },
      blockUser(user) {  
            axios({
                method: 'PUT',
                url: `${url}/v1/web/users/${user.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.blockStatus
                }
            })
            .then((response) => {
                if(response.data.data.status === "blocked") {
                    this.userInfo()
                }
            }) 
            .catch((error) => {
                console.log(error)
            })
        },
        unblockUser(user) {  
            axios({
                method: 'PUT',
                url: `${url}/v1/web/users/${user.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    status : this.unblockStatus
                }
            })
            .then((response) => {
                this.userInfo();
                response;
            }) 
            .catch((error) => {
                console.log(error)
            })
        },
        closeWalletModal() {
            this.isWalletVisible = false;
            this.paymentStatus();
        },

        closeSuspendModal() {
            this.isSuspendModal = false;
            // this.userInfo()
        },
        
        closeModal() {
            this.isModalVisible = false;
            this.paymentStatus();
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            }
        },
        
        userInfo() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((res) =>{
                this.user = res.data.data;
                this.cashPaymentStatus = this.user.cashPayment;
                localStorage.setItem("user-id", this.user.id)
            })
            .catch((err)=>err.json);
        },

        paymentStatus() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/${this.id}`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((res) =>{
                let cashStatus = res.data.data.cashPayment;
                this.cashPaymentStatus = cashStatus;
                let walletStatus = res.data.data.walletPayment;
                this.walletPaymentStatus = walletStatus; 
                if (this.cashPaymentStatus === true) {
                    this.cashPaymentDisplay = "Disable Cash Payment"; 
                } else {
                    this.cashPaymentDisplay = "Enable Cash Payment"
                }

                if (this.walletPaymentStatus === true) {
                    this.walletPaymentDisplay = "Disable Wallet Payment"; 
                } else {
                    this.walletPaymentDisplay = "Enable Wallet Payment"
                }
            })
            .catch((err) =>err.json);
        },
        getWalletAccountName() {
            axios({
            method: 'GET',
            url: `${url}/v1/web/users/wallet/${this.id}`,
            headers: {
                'Content-type': 'application/json',
                'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
              let detail = res.data.data;
              this.userWallet = detail;
          })
          .catch((err) =>err.json)
        }
        
     }
}
</script>


 